var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3.75h-.75V3A2.25 2.25 0 0 0 10.25.75h-7.5A2.25 2.25 0 0 0 .5 3v9a2.25 2.25 0 0 0 2.25 2.25h10.5A2.25 2.25 0 0 0 15.5 12V6a2.25 2.25 0 0 0-2.25-2.25Zm-10.5-1.5h7.5A.75.75 0 0 1 11 3v.75H2.75a.75.75 0 0 1 0-1.5ZM14 9.75h-.75a.75.75 0 1 1 0-1.5H14v1.5Zm0-3h-.75a2.25 2.25 0 0 0 0 4.5H14V12a.75.75 0 0 1-.75.75H2.75A.75.75 0 0 1 2 12V5.122c.241.085.495.128.75.128h10.5A.75.75 0 0 1 14 6v.75Z",
    fill: "#5CFA46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.af733efb58709977c74e84a4244f13a9.svg";
export { ForwardRef as ReactComponent };